"use strict";
import { __exports as e } from "./index.es341.js";
import { __require as f } from "./index.es306.js";
var n;
function p() {
  return n ? e : (n = 1, (function(r) {
    Object.defineProperty(r, "__esModule", {
      value: !0
    }), Object.defineProperty(r, "pathHasPrefix", {
      enumerable: !0,
      get: function() {
        return u;
      }
    });
    const s = f();
    function u(t, a) {
      if (typeof t != "string")
        return !1;
      const { pathname: i } = (0, s.parsePath)(t);
      return i === a || i.startsWith(a + "/");
    }
  })(e), e);
}
export {
  p as __require
};
//# sourceMappingURL=index.es319.js.map
